if (!customElements.get('adev-card-images')) {
    customElements.define('adev-card-images', class adevCardImages extends HTMLElement {
        constructor() {
            super();
        }
        
        
        initSlider(){
            this.sliderEl = new Flickity(this, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: true,
                initialIndex: this.dataset.initialIndex ? parseInt(this.dataset.initialIndex, 10) : 0,
            });
        }

        destroySlider(){
            if(this.sliderEl){
                this.sliderEl.destroy();
            }
        }

        updateCurrentMedia(index){
            if(this.sliderEl){
                this.sliderEl.select(index);
            }
        }

        connectedCallback() {
            this.initSlider();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}

if (!customElements.get('adev-video')) {
    customElements.define('adev-video', class adevVideo extends HTMLElement {
        constructor() {
            super();
            this.observer = null;
            this.videoLoaded = false;
            this.handleIntersect = this.handleIntersect.bind(this);
        }

        initObserver() {
            if (!('IntersectionObserver' in window)) {
                this.loadVideo();
                return;
            }

            this.observer = new IntersectionObserver(this.handleIntersect, {
                root: null,
                rootMargin: '300px 0px',
                threshold: 0.01,
            });

            this.observer.observe(this);
        }

        destroyObserver() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        }

        handleIntersect(entries) {
            const isVisible = entries.some((entry) => entry.isIntersecting || entry.intersectionRatio > 0);

            if (isVisible) {
                this.loadVideo();
            }
        }

        loadVideo() {
            if (this.videoLoaded) return;

            const videoTemplate = this.querySelector('script[type="text/html"]');
            if (!videoTemplate) return;

            this.innerHTML = videoTemplate.innerHTML.trim();
            this.videoLoaded = true;
            this.destroyObserver();
        }

        connectedCallback() {
            if (!this.videoLoaded) {
                this.initObserver();
            }
        }

        disconnectedCallback() {
            this.destroyObserver();
        }
    });
}


